var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"font-size-24 cloud-upload",attrs:{"href":"#"}},[_c('router-link',{attrs:{"target":"_blank","to":"/cloud-store"}},[_c('a-icon',{directives:[{name:"add-class-hover",rawName:"v-add-class-hover",value:('text-primary'),expression:"'text-primary'"}],attrs:{"type":"cloud-upload"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }